import { render, staticRenderFns } from "./SpriteIcon.vue?vue&type=template&id=598af8ac&scoped=true&"
import script from "./SpriteIcon.vue?vue&type=script&lang=ts&"
export * from "./SpriteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SpriteIcon.vue?vue&type=style&index=0&id=598af8ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598af8ac",
  null
  
)

export default component.exports